<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px" />
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-5 col-sm-5 col-lg-5">
                                <label for="batch_id">Select Batch <span style="color: red">*</span></label>
                                <select v-model="search_data.batch_id" v-validate="'required'" id="batch_id" name="batch_id"
                                    class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch</option>
                                    <option v-for="(batch, index) in batches" :key="index" :value="batch.id">
                                        {{ batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Batch
                                </div>
                            </div>
                            <div class="col-3 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">
                                    Search
                                </button>
                            </div>
                        </div>

                    </form>
                </b-card>

                <b-card>
                    <div class="row">
                        <div class="col-12">
                            <span class="" style="font-size: 18px;"><b>Total paid amount to all the trainees as
                                    honorarium: {{ moneyFormat(payableAmount) }}</b>
                                Tk.</span>
                        </div>
                    </div>
                </b-card>
                <b-card v-if="Object.keys(batch_info).length !== 0">
                    <div class="text-center clear" style="margin-top: -18px;">
                        <span style="font-size: 18px">
                            Trade Name : {{ batch_info.trade.desc }}<br />
                            Batch No : {{ batch_info.batch_no }}<br />
                        </span>
                    </div>
                </b-card>

                <b-card v-if="flag">
                    <div v-if="trainee_batches.length > 0" class="row mb-2">
                        <div class="col-sm-12">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainee_batches.length
                            }}</span>
                            <download-excel class="btn btn-light float-right" :data="trainee_batches"
                                :fields="trainee_batch_fields" :meta="json_meta" worksheet="Trainee Voucher"
                                name="Trainee Voucher.xls">
                                Download Excel
                            </download-excel>

                            <button class="btn btn-light float-right mr-1" @click="dowonloadPdf">
                                <div v-if="loading" class="spinner-border spinner-border-sm text-muted"
                                    style="margin-bottom : 2px;">
                                </div>
                                Download PDF
                            </button>
                        </div>
                    </div>
                    <div class="scrollable-table" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                                <tr>
                                    <th>SL</th>
                                    <th>Download Receipt</th>
                                    <th>Trade name</th>
                                    <th>Batch No</th>
                                    <th>Trainees Name</th>
                                    <th>Fathers Name</th>
                                    <th>Mobile No</th>
                                    <th>Bank Name</th>
                                    <th>Bank Branch</th>
                                    <th>Account Number</th>
                                    <th>Total Attendance</th>
                                    <th>total Absent</th>
                                    <th>Daily allowance</th>
                                    <th>Total Amount</th>
                                    <th>Vat</th>
                                    <th>Tax</th>
                                    <th class="text-right">Payable amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(trainee, index) in trainee_batches" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <a href="javascript:void(0)" @click="printReceipt(trainee)"><i class="fa fa-print"
                                                aria-hidden="true"></i></a>
                                    </td>
                                    <td>{{ trainee.trade_desc }}</td>
                                    <td>{{ trainee.batch_no }}</td>
                                    <td>{{ trainee.rep_name ? trainee.rep_name : trainee.name }}</td>
                                    <td>{{ trainee.rep_father_husband_name ? trainee.rep_father_husband_name :
                                        trainee.father_husband_name
                                    }}</td>
                                    <td>{{ trainee.rep_mobile ? trainee.rep_mobile : trainee.mobile }}</td>
                                    <td>{{ trainee.trainee_bank ? trainee.trainee_bank.bank.desc : '' }}</td>
                                    <td>{{ trainee.trainee_bank ? trainee.trainee_bank.branch_name : '' }}</td>
                                    <td>{{ trainee.trainee_bank ? trainee.trainee_bank.account_no : '' }}</td>
                                    <td>{{ trainee.total_present_attendance ? trainee.total_present_attendance : '0' }}
                                    </td>
                                    <td>{{ trainee.total_absent_attendance ? trainee.total_absent_attendance : '0' }}
                                    </td>
                                    <td class="text-right">{{ trainee.trainee_conveyances ?
                                        moneyFormat(trainee.trainee_conveyances) : '0' }}</td>
                                    <td class="text-right">{{ trainee.sub_total ? moneyFormat(trainee.sub_total) : '0' }}
                                    </td>
                                    <td>{{ trainee.vat ? trainee.vat : '0' }}</td>
                                    <td>{{ trainee.tax ? trainee.tax : '0' }}</td>
                                    <td class="text-right">{{ trainee.total ? moneyFormat(trainee.total) : '0' }}</td>

                                </tr>

                                <tr>
                                    <td colspan="13"></td>
                                    <td class="text-right" colspan="4">
                                        <b>{{ batch_info.trade.desc }} : Batch {{ batch_info.batch_no }} (Total Payable) =
                                            {{
                                                totalPayableForBatch(trainee_batches)
                                            }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

import moment from "moment";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default {
    page: {
        title: "Voucher",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            loading: false,
            title: "Voucher List",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Voucher",
                    active: true
                }
            ],
            payableAmount: 0,
            batches: [],
            trainee_batches: {},
            batch_info: {},
            search_data: {
                batch_id: ''
            },
            validation_errors: {},
            start_date: "",
            flag: false,
            trainee_batch_fields: {
                'SL': 'sl',
                'Trade name': 'trade_desc',
                'Batch No': 'batch_no',
                'Trainees Name': {
                    callback: (value) => {
                        return `${value.rep_name ? value.rep_name : value.name}`;
                    }
                },
                'Fathers Name': {
                    callback: (value) => {
                        return `${value.rep_father_husband_name ? value.rep_father_husband_name : value.father_husband_name}`;
                    }
                },
                'Mobile No': {
                    callback: (value) => {
                        return `${value.rep_mobile ? value.rep_mobile : value.mobile}`;
                    }
                },
                'Bank Name': {
                    callback: (value) => {
                        return `${value.trainee_bank ? value.trainee_bank.bank.desc : 'N/A'}`;
                    }
                },
                'Bank Branch': {
                    callback: (value) => {
                        return `${value.trainee_bank ? value.trainee_bank.branch_name : 'N/A'}`;
                    }
                },
                'Account Number': {
                    callback: (value) => {
                        return `${value.trainee_bank ? value.trainee_bank.account_no : ''}`;
                    }
                },
                'Total Attendance': {
                    callback: (value) => {
                        return `${value.total_present_attendance ? value.total_present_attendance : 0}`;
                    }
                },
                'total Absent': {
                    callback: (value) => {
                        return `${value.total_absent_attendance ? value.total_absent_attendance : 0}`;
                    }
                },
                'Daily allowance': {
                    callback: (value) => {
                        return `${value.trainee_conveyances ? value.trainee_conveyances : 0}`;
                    }
                },
                'Total Amount': {
                    callback: (value) => {
                        return `${value.sub_total ? value.sub_total : 0}`;
                    }
                },
                'Vat': {
                    callback: (value) => {
                        return `${value.vat ? value.vat : 0}`;
                    }
                },
                'Payable amount': {
                    callback: (value) => {
                        return `${value.total ? value.total : 0}`;
                    }
                },
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
        };
    },

    mounted() {
        this.getBatches();
        this.getPayableAmount()
    },
    methods: {
        totalPayableForBatch(trainee_batches) {
            let amount = 0
            trainee_batches.forEach(function (trainee) {
                amount += trainee.total
            })

            return this.moneyFormat(amount)
        },
        moneyFormat(amount) {
            let floatAmountAsString = parseFloat(amount).toFixed(2)
            return parseFloat(floatAmountAsString).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })
        },
        printReceipt(trainee) {
            const jsPdf = new jsPDF({
                orientation: 'l',
                unit: 'cm',
                format: [250, 400]
            })
            jsPdf.setFontSize(12);
            jsPdf.text('ILRP Training Program', 5, 1)
            jsPdf.text('Name: ' + (trainee.rep_name ? trainee.rep_name : trainee.name), 1, 2);
            jsPdf.text('Father name: ' + (trainee.rep_father_husband_name ? trainee.rep_father_husband_name : trainee.father_husband_name), 1, 2.7);
            jsPdf.text('Trade name: ' + (trainee.trade_desc), 1, 3.4);
            jsPdf.text('Bank: ' + (trainee.trainee_bank ? trainee.trainee_bank.bank.desc : ''), 1, 4.3);
            jsPdf.text('Branch: ' + (trainee.trainee_bank ? trainee.trainee_bank.branch_name : ''), 1, 5);
            jsPdf.text('Payable Amount: ' + trainee.total, 1, 5.7);
            jsPdf.text('--------------------------------------', 1, 6.8);
            jsPdf.text('Authorized by', 2, 7.6);
            jsPdf.save('honorarium-' + (trainee.rep_name ? trainee.rep_name : trainee.name) + '.pdf');
        },
        async dowonloadPdf() {
            this.loading = true
            // let response = await http.post("api/trainees/age/download_trainees", this.search_data);
            var data = []
            try {
                // console.log(this.mouza_trainees)
                // return
                this.trainee_batches.forEach(function (value) {
                    data.push([
                        value.trade_desc,
                        value.batch_no,
                        value.rep_name ? value.rep_name : value.name,
                        value.rep_father_husband_name ? value.rep_father_husband_name : value.father_husband_name,
                        value.rep_mobile ? value.rep_mobile : value.mobile,
                        value.trainee_bank ? value.trainee_bank.bank.desc : 'N/A',
                        value.trainee_bank ? value.trainee_bank.branch_name : 'N/A',
                        value.trainee_bank ? value.trainee_bank.account_no : 'N/A',
                        value.total_present_attendance ? value.total_present_attendance : 0,
                        value.total_absent_attendance ? value.total_absent_attendance : 0,
                        value.trainee_conveyances ? value.trainee_conveyances : 0,
                        value.sub_total ? value.sub_total : 0,
                        value.vat ? value.vat : 0,
                        value.tax ? value.tax : 0,
                        value.total ? value.total : 0
                    ])
                })
            }
            catch (e) {
                console.log(e.message)
            }

            const doc = new jsPDF({ orientation: 'l' })
            autoTable(doc, {
                head: [[
                    'Trade name',
                    'Batch No',
                    'Trainees Name',
                    'Fathers Name',
                    'Mobile No',
                    'Bank Name',
                    'Bank Branch',
                    'Account Number',
                    'Total Attendance',
                    'Total Absent',
                    'Daily allowance',
                    'Total Amount',
                    'Vat',
                    'Tax',
                    'Payable Amount'
                ]],
                body: data,
            })
            doc.save('voucher-batch-report.pdf')
            this.loading = false
        },
        getBatches() {
            http.get("api/batch/trainee/getBatch").then(response => {
                if (!response.error) {
                    this.batches = response.data.batches;
                }
            });
        },
        search() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    http
                        .post("api/trainee/voucher/report", this.search_data)
                        .then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.trainee_batches = response.data.trainee_batches;
                                this.batch_info = response.data.batch_info;
                            }
                        });
                }
            });
        },
        getPayableAmount() {
            http
                .get("api/trainee/voucher/report/total")
                .then(response => {
                    if (!response.error) {
                        console.log(response.data)
                        this.payableAmount = response.data;
                    }
                });
            return 0
        }
    },
};
</script>
<style lang="scss">
.vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
}

.c-container {
    margin-right: 5px;
}

.scrollable-table {
    overflow-x: auto;
    white-space: nowrap;
}
</style>